"use client";
import React from "react";
import { Button, Grid, Box, Typography } from "@mui/material";
import notFoundImg from "../../assets/svg/404.svg";
import Link from "next/link";

function NotFound() {
  return (
    <Box>
      <Grid container>
        {/* Left Text Container */}
        <Grid item md={6} justifyContent={"flex-end"} display={"flex"}>
          <img src={notFoundImg.src} alt="Not Found" style={{maxWidth:"600px"}}/>
        </Grid>
        <Grid item md={6} sx={{display:"flex", justifyContent:"center", flexDirection:"column"}}>
          <Typography variant="h1" gutterBottom sx={{ fontSize: "5rem" }}>
            Oops...
          </Typography>
          <Typography variant="h6" gutterBottom>
            Page not found
          </Typography>
          <Typography variant="body1" gutterBottom pb={3}>
            Looks like this page does not exist
          </Typography>
          <Link href="/" passHref>
            <Button variant="contained">
              Go to Home
            </Button>
          </Link>
        </Grid>

        {/* Right Image Container */}
      </Grid>
    </Box>
  );
}

export default NotFound;
